import i18n from '@/plugins/i18n';

export class BaseNotification {
  constructor(data) {
    this.id = data.id || null;
    this.group = data.group || null;
    this.is_received = data.is_received || null;
    this.client_id = data.client_id || null;
    this.created_at = data.created_at || null;
    this.params = data.params || {};
    this.theme = data.theme || 'alert';
    this.type = data.type || 'custom';
  }

  get is_custom() {
    return this.type === 'custom';
  }

  getText() {
    const props = this.getI18nProps();
    return i18n.t(props.path, props.params);
  }

  static THEME_ALERT = 'alert';
  static THEME_SUCCESS = 'success';
  static THEME_WARNING = 'warning';
  static THEME_ERROR = 'error';
  static THEME_INFO = 'info';

  getTheme() {
    return BaseNotification.THEME_ALERT;
  }

  /**
   *
   * @return
   * {
   *    path: string - путь до локализации
   *    params: object - заменяет значения в строке i18n
   *    link.href: RouterLink - ссылка,
   *    link.label: путь до локализации
   * }
   */
  getI18nProps() {
    return {
      path: `notify.notification.${this.type}.body`
    };
  }
}
